// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EnxS","label":"styles_label__qb0R7"};